<app-form-basket
    [groupList]="groupList"
    [userList]="userList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-basket>
